import React, { Component, useState, useEffect,useRef } from 'react'
import { Link, useHistory } from 'react-router-dom'
import TextField from '../component/TextField'

import CopyIcon from '../icons/copyicon'
import VideoImageFile from '../component/VideoImageFile'
import VideoOnlyUpload from './VideoOnlyUpload'
import FpgMinusIcon from '../icons/fpgminusicon'
import FpgPlusIcon from '../icons/fpgplusicon'
import TextEditor from '../component/TextEditor'
import SearchIcon from './../icons/searchicon'
import serachIcon from './../assets/images/search.svg'
import HighlightTable from '../component/HighlightTable'
import FpgeeditIcon from '../icons/fpgediticon'
import FpgpublishIcon from '../icons/fpgpublishicon'
import FpgDeleteIcon from '../icons/fpgdeleteicon'
import FpgDisableIcon from '../icons/fpgdisableicon'
import Dropdown from '../component/Dropdown'
import DropdownMaster from '../component/DropdownMaster';
import Textarea from '../component/Textarea'
import service from '../services'

//Redux Connect
import { useSelector } from 'react-redux';
import { ActCreators } from '../redux/bindActionCretor'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import UploadForm from '../component/fpg/create/UploadForm'

//moment import
import moment from "moment-timezone";

// editor
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Editor } from 'react-draft-wysiwyg';

//import AWS from "aws-sdk";
import SimpleReactValidator from 'simple-react-validator';
import AWS from "aws-sdk";
import PopUpCustomAll from '../component/fpg/create/popUpCustomAll'
import HighlightsFh from './highlightsFh'
import ImageOnlyUpload from './ImageOnlyUpload'
import ErrorPopUp from '../component/errorPopUp'
import { set } from 'lodash'
import commonImage from '../commonImage'
let sub;
const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActCreators, dispatch)
};
let hoursStart;
let minutesStart;
let stateStart;

const EXT_IMAGES = /\.(svg|png|apng|jpeg|jpg|ico|hdr|bmp|webp|gif|tiff|tif|jp2|rgb|dds|cur|tga|heic|jfif|pgm|jpe|xpm|exr|map|ppm|g3|wbmp|jbg|pcx|pdb|avif|jps|rgba|heif|fax|xbm|yuv|pcd|pict|xwd|pal|vips|pgx|pbm|jbig|picon|ras|pct|fts|hrz|ipl|mng|mtv|otb|palm|pam|pfm|pnm|rgbo|sgi|sun|uyvy|viff|xv|g4|rgf|six|sixel|jif|jfi)$/i;
const EXT_VIDEO = /\.(avi|wmv|mpeg|webm|mov|mpg|divx|mpeg-2|3gp|flv|swf|m4v|ogv|mkv|mjpeg|vob|xvid|mts|av1|ts|avchd|hevc|asf|mxf|m2v|3g2|rmvb|m2ts|wtv|f4v|rm|mp4)$/i;

function HighlightDetailView() {
  const history = useHistory();
  const _HighlightEditId = useSelector(state => state.HighlightEditId)
  // const _HighlightList = useSelector(state => state.HighlightList)

  const [apiserve, setApiserve] = useState(new service());
  const [updateStatus, setUpdateStatus] = useState(null)

  const [activetab, setActivetab] = useState(0)
  const [imagePreloader, setImagePreloader] = useState(false)
  const [imgFile, setImgFile] = useState(null);
  const [imgFileUrl, setImgFileUrl] = useState(null);
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [isEdit, setIsEdit] = useState(false)
  const [videoPreLoader, setVideoPreLoader] = useState(false)
  const [type, settype] = useState([
    {
      name:"Stories",
      _id:"Stories"
    },
    { 
      name:"News",
      _id:"News"
    },
    { 
      name:"In The Press",
      _id:"In The Press"
    }
  ])
  const [position, setPosition] = useState(["Top", "Bottom"])
  const [data, setData] = useState([
    {
      "label": "manage Highlights",
      "Content": "",
    },
    {
      "label": "featured highlights",
      "Content": "",
    },
  ])
  const [highLight, setHighLight] = useState(null)
  const [highLInfo, setHighLInfo] = useState('')
  const [highLightFormate,sethighLightFormate]=useState(
    [
      {
        name:"Blog Post",
        _id:"Blog Post"
      },
      { 
        name:"External link",
        _id:"External link"
      }
    ]
    )
  const [highlightStateList, setHighlightStateList] = useState(null);
  const [deleteImagePopup, setDeleteImagePopup] = useState(false)
  const [deleteFilePopup, setDeleteFilePopup] = useState(false)
  const [messageModal, setMessageModal] = useState(false)
  const [editorState, setEditorState] = useState(EditorState.createEmpty())
  const [errorMsg, setErrorMsg] = useState('')
  const [errorPopup, setErrorPopup] = useState(false);
  const [disableHighLight, setDisableHighLight] = useState(false)
  const [publishHighLight, setPublishHighLight] = useState(false)
  const [deleteHighLight, setDeleteHighLight] = useState(false)
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);
  
    const validator = useRef(new SimpleReactValidator(
        {
            autoForceUpdate: this,
            validators: {
                highlightTitle: {  // name the rule
                  message: 'This Field is required.',
                  rule: (val, params, validator) => {
                      return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                  },
                  required: true  // optional
              } 
            }
        }
    )) 

  useEffect(() => {
    let data = {
      id: _HighlightEditId
    }
    apiserve.sendevent("homePage|featuredHighlight|getListById", data)
    // eventCall();
  }, [_HighlightEditId])


  useEffect(() => {
    const imgUp = () => {
      const fileList = Math.round((imgFile.size / 1024));
      if (fileList >= 2048) {
        setErrorMsg('Please upload a file smaller than 2 MB')
        setErrorPopup(true)
        return false;
      }
      if (imgFile.type === 'image/png' || imgFile.type === 'image/jpg' || imgFile.type === 'image/jpeg' || imgFile.type === 'image/gif' || imgFile.type === 'image/jfif') {
        setTimeout(() => {
          imageUploadOne(imgFile, imgFileUrl);
        }, 0)
      } else {
        setErrorMsg('Please upload a file for PNG,JPG or JPEG')
        setErrorPopup(true)
      }
    }
    if (imgFile) imgUp()
  }, [imgFile]);

  useEffect(() => {
    const fileUpload = () => {
      if (file.type === 'video/mp4') {
        if (file) {
          if (file.size > 100e6) {
            setErrorMsg("Please upload a video smaller than 100 MB");
            setErrorPopup(true);
            return false;
          }
          if (file.type === "video/mp4") {
            setTimeout(() => {
              fileUploder(file, fileUrl);
            }, 1000);
          } else {
            setErrorMsg("Please upload only MP4 file");
            setErrorPopup(true);
          }
        }
      }
      else if ((file && file.type === "image/png") || (file && file.type === "image/jpg") || (file && file.type === "image/jpeg") || (file && file.type === "image/gif") || (file && file.type === "image/jfif")) {
        const fileList = Math.round(file && file.size / 1024);
        if (fileList >= 2048) {
          setErrorMsg('Please upload a file smaller than 2 MB')
          setErrorPopup(true)
          return false;
        }
        if ((file && file.type === "image/png") || (file && file.type === "image/jpg") || (file && file.type === "image/jpeg") || (file && file.type === "image/gif") || (file && file.type === "image/jfif")) {
          setTimeout(() => {
            fileUploder(file, fileUrl);
          }, 0)
        } else {
          setErrorMsg('Please upload a file for PNG,JPG or JPEG')
          setErrorPopup(true)
        }
      }
    }
    if (file) fileUpload();
  }, [file])

  useEffect(() => {
    // debugger
    sub = apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "homePage|featuredHighlight|getListById":
          if (!response.error) {
            // debugger
            for (var i = 1; i <= 4; i++) {
              if (response.data.highlightFormat !== "External link") {
              // debugger
              if (typeof response.data[`paragraph${i}`] !== "object") {
                const blocksFromHtml = htmlToDraft(response.data[`paragraph${i}`]);
                const { contentBlocks, entityMap } = blocksFromHtml;
                const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                response.data[`paragraph${i}`] = EditorState?.createWithContent(contentState);
              }
              }
            }


            setHighLInfo(response.data)
            
          } else {
          }
          break;
        case "homePage|featuredHighlight|updateStatus":
          if (!response.error) {
            const { status } = response.data;
            setHighLInfo(q => ({ ...q, status }))
          } else {
            setErrorMsg(response.data.error ? response.data.error : response.data)
            setErrorPopup(true)
          }
          break;
        case "homePage|featuredHighlight|remove":
          if (!response.error) {
            history.push('/highlights')
          } else {
            setErrorMsg(response.data.error ? response.data.error : response.data)
            setErrorPopup(true)
          }
          break;
        case "homePage|featuredHighlight|edit":
          if (!response.error) {
            apiserve.success("Update Successfully.")
          } else {
            setErrorMsg(response.data.error ? response.data.error : response.data)
            setErrorPopup(true)
          }
          break;
      }

    })
    return () => {
      sub.unsubscribe()
    }
  }, [])

  const insideImagechange = (e) => {
    const { value } = e.target
    if (highLInfo.highlightType === "Stories" || highLInfo.highlightType === "News") {
      highLInfo.highlightImage1Url = value
      setHighLInfo({
        ...highLInfo,
        highlightImage1Url: value
      })
    }
    else {
      highLInfo.highlightImage1Url = value
      setHighLInfo({
        ...highLInfo,
        highlightImage1Url: value
      })
    }
    setDeleteImagePopup(false)
  }
  const insideFilechange = (e) => {
    const { value } = e.target
    highLInfo.highlightImage2Url = value
    setHighLInfo({
      ...highLInfo,
      highlightImage2Url: value
    })
    setDeleteFilePopup(false)
  }
  const onDeleteImagePopup = () => {
    if (["Stories", "News", "In The Press"].includes(highLInfo.highlightType)) highLInfo.highlightImage1 = ''
    else highLInfo.highlightImage1 = ''
    setHighLInfo(highLInfo)
    setDeleteImagePopup(false)
  }
  const onDeleteFilePopup = (e, id) => {
    highLInfo.highlightImage2 = ''
    setHighLInfo(highLInfo)
    setDeleteFilePopup(false)

  }
  const fileUploder = (file, img) => {
    setVideoPreLoader({ videoPreLoader: true })
    var fileSet = commonImage(file,false,'',img)
    fileSet.then((value) => {
        setVideoPreLoader(false)
        const Info = { ...highLInfo }
        Info.highlightImage2 = value
        setHighLInfo(Info)
      });
  };
  const handleImage = (e, i) => {

    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      setImgFile(file);
      setImgFileUrl(event.target.result);
    };
  }
  // textbox video change 
  const OnchangeVideo = (e) => {
    const { value } = e.target
    const Info = { ...highLInfo }
    Info.highlightImage2 = value
    setHighLInfo(Info)
  }

  const imageUploadOne = (file, img) => {
    setImagePreloader(true)
    var fileSet = commonImage(file,false,'',img)
    fileSet.then((value) => {
        setImagePreloader(false)
        const Info = { ...highLInfo }
        if (Info.highlightType === "Stories" || Info.highlightType === "News" ||Info.highlightType === "In The Press" ) {
          Info.highlightImage1 = value
        }
        else {
          Info.highlightImage1 = value
        }
        setHighLInfo(Info)
      });
  };
  const handleDisableHighLight = (id, status) => {

    let data = {
      id: id,
      status: 2
    }
    setDisableHighLight(true)
    setUpdateStatus(data)
  }
  const handlePublishHighLight = (id) => {

    let data = {
      id: id,
      status: 1
    }
    setPublishHighLight(true)
    setUpdateStatus(data)
  }
  const closeAdminUser = () => {
    setDeleteFilePopup(false);
    setDeleteImagePopup(false);
    setMessageModal(false);
    setDisableHighLight(false);
    setDeleteHighLight(false);
    setPublishHighLight(false);
  };

  const handleDeleteHighLight = () => { setDeleteHighLight(true); }

  const disableHighLightPopupYes = () => {
    apiserve.sendevent("homePage|featuredHighlight|updateStatus", updateStatus);
    // eventCall();
  }
  const publishHighLightPopupYes = () => {
    apiserve.sendevent("homePage|featuredHighlight|updateStatus", updateStatus);
    // eventCall();
  }

  const deleteHighLightPopupYes = () => {
    // debugger
    apiserve.sendevent("homePage|featuredHighlight|remove", {
      id: _HighlightEditId
    });
    // eventCall();
  }
  const TabClick = (index) => { ; setActivetab(index); }

  const EditFeatured = () => { setIsEdit(true) }

  const onInputChange = (e) => {
    const { name, value } = e.target
    setHighLInfo({
      ...highLInfo,
      [name]: value
    })
  }
  const onEditorStateChange = (e, p) => {
    setHighLInfo({
      ...highLInfo,
      [p]: e
    });
  }

  const dropChange = (e) => {
    const { name, value } = e.target;
    setHighLInfo({
        ...highLInfo,
        [name]: value
    })
      
    forceUpdate();
    
  }
  // const dropChangeFormate=(e)=>{
  // 	const { name, value } = e.target
  // setHighLInfo({
  // 	...highLInfo,
  // 	[name]: value
  // })
  // }
  const editHighLight = (id) => {
   
    try {
      if (validator.current.allValid() && (["Blog Post"].includes(highLInfo.highlightFormat))) {
       
        // if (highLInfo._id){
        // let paragraph1 = draftToHtml(convertToRaw(highLInfo.paragraph1.getCurrentContent()))
        // let paragraph2 = draftToHtml(convertToRaw(highLInfo.paragraph2.getCurrentContent()))
        // let paragraph3 = draftToHtml(convertToRaw(highLInfo.paragraph3.getCurrentContent()))
        // let paragraph4 = draftToHtml(convertToRaw(highLInfo.paragraph4.getCurrentContent()))
        let paragraph1 = highLInfo && highLInfo.paragraph1 ? draftToHtml(convertToRaw(highLInfo && highLInfo.paragraph1.getCurrentContent())) : ''
            let paragraph2 = highLInfo && highLInfo.paragraph2 ? draftToHtml(convertToRaw(highLInfo && highLInfo.paragraph2.getCurrentContent())) : ''
            let paragraph3 = highLInfo && highLInfo.paragraph3 ? draftToHtml(convertToRaw(highLInfo && highLInfo.paragraph3.getCurrentContent())) : ''
            let paragraph4 = highLInfo && highLInfo.paragraph4 ? draftToHtml(convertToRaw(highLInfo && highLInfo.paragraph4.getCurrentContent())) : ''

        const data = {
          id: highLInfo._id,
          highlightType: highLInfo.highlightType === undefined ? "Stories" : highLInfo.highlightType,
          highlightFormat: highLInfo.highlightFormat === undefined ? "Blog Post" : highLInfo.highlightFormat,
          highlightTitle: highLInfo.highlightTitle,
          featuredHighlightImagePosition: highLInfo.featuredHighlightImagePosition ? highLInfo.featuredHighlightImagePosition : "Top",
          featuredHighlightCTATitle: highLInfo.featuredHighlightCTATitle,
          highlightImage1: highLInfo.highlightImage1,
          highlightImage1Url: highLInfo.highlightImage1Url,
          mediaDescription1: highLInfo.mediaDescription1,
          paragraph1: paragraph1,
          paragraph2: paragraph2,
          quote: highLInfo.quote,
          quoteBy: highLInfo.quoteBy,
          paragraph3: paragraph3,
          highlightImage2: highLInfo.highlightImage2,
          highlightImage2Url: highLInfo.highlightImage2Url,
          mediaDescription2: highLInfo.mediaDescription2,
          paragraph4: paragraph4,
          status: highLInfo.status
        }
       
        apiserve.sendevent("homePage|featuredHighlight|edit", data)
    
     
      }
      // else if (highLInfo.highlightFormat === "External link") {
      else if (validator.current.allValid() && (["External link"].includes(highLInfo.highlightFormat))) {
      // debugger
        const data = {
          id: highLInfo._id,
          highlightType: highLInfo.highlightType === undefined ? "Stories" : highLInfo.highlightType,
          highlightFormat: highLInfo.highlightFormat === undefined ? "Blog Post" : highLInfo.highlightFormat,
          highlightTitle: highLInfo.highlightTitle,
          highLightOpeningText: highLInfo.highLightOpeningText,
          highlightImage1Url: highLInfo.highlightImage1Url,
          mediaDescription1: highLInfo.mediaDescription1,
          featuredHighlightCTATitle: highLInfo.featuredHighlightCTATitle,
          highlightImage1: highLInfo.highlightImage1,
          featuredHighlightCTAUrl: highLInfo.featuredHighlightCTAUrl,
          // highlightImage1Url: highLInfo.highlightImage1,
        }
 
         apiserve.sendevent("homePage|featuredHighlight|edit", data)
    
      }
      // else{
      // 	const data = {
      // 		id: highLInfo._id,
      // 		highlightType:highLInfo.highlightType === undefined ? "Stories" : highLInfo.highlightType,
      //         highlightFormat:highLInfo.highlightFormat === undefined ? "Blog Post" : highLInfo.highlightFormat,
      // 	}
      // 	apiserve.sendevent("homePage|featuredHighlight|edit", {data})
      // }
      // eventCall();
      else{
        validator.current.showMessages()
        forceUpdate()
      }
    } catch (error) {
      console.log("error---",error);
    }
  }

  const image = () => {
    const { imageUrl } = apiserve;
    if (highLInfo.highlightFormat === "External link") return highLInfo.highlightImage1 ? imageUrl + highLInfo.highlightImage1 : highLInfo.highlightImage1Url
    return highLInfo.highlightImage1 ? imageUrl + highLInfo.highlightImage1 : highLInfo.highlightImage1Url
  }

  const imageUrlValue = () => {
    if (highLInfo.highlightFormat === "External link") return highLInfo.highlightImage1Url
    return highLInfo.highlightImage1Url
  }

  const showDeleteIcon = () => {
    if (highLInfo.highlightFormat === "External link") return highLInfo.highlightImage1 ? highLInfo.highlightImage1 : ''
    return highLInfo.highlightImage1 ? highLInfo.highlightImage1 : ''
  }

  const covertToHtml = (paragraph) => {
    // debugger
    if (paragraph) {
      const name = convertToRaw(paragraph.getCurrentContent());
      const markup = draftToHtml(name);
      return markup;
    }
  }

  const onChangeFile = (e, ref) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = (event) => {
        setFile(file)
        setFileUrl(event.target.result)
      };
      if (ref) ref.current.value = "";
    } catch (error) {
    }
  };
  const cancelFn = () => {
    history.push('/highlights')
  }
  const previewRecordTalk = (e) => {
    // debugger
    e.preventDefault()
    let data = {};
    try {
    if (["Blog Post", "Stories","In The Press"].includes(highLInfo.highlightFormat)) {
      let paragraph1 = draftToHtml(convertToRaw(highLInfo.paragraph1?.getCurrentContent()))
      let paragraph2 = draftToHtml(convertToRaw(highLInfo.paragraph2?.getCurrentContent()))
      let paragraph3 = draftToHtml(convertToRaw(highLInfo.paragraph3?.getCurrentContent()))
      let paragraph4 = draftToHtml(convertToRaw(highLInfo.paragraph4?.getCurrentContent()))
      data = {
        id: highLInfo._id,
        highlightType: highLInfo.highlightType === undefined ? "Stories" : highLInfo.highlightType,
        highlightFormat: highLInfo.highlightFormat === undefined ? "Blog Post" : highLInfo.highlightFormat,
        highlightTitle: highLInfo.highlightTitle,
        featuredHighlightImagePosition: highLInfo.featuredHighlightImagePosition ? highLInfo.featuredHighlightImagePosition : "Top",
        featuredHighlightCTATitle: highLInfo.featuredHighlightCTATitle,
        highlightImage1: highLInfo.highlightImage1,
        highlightImage1Url: highLInfo.highlightImage1Url,
        mediaDescription1: highLInfo.mediaDescription1,
        paragraph1: paragraph1,
        paragraph2: paragraph2,
        quote: highLInfo.quote,
        quoteBy: highLInfo.quoteBy,
        paragraph3: paragraph3,
        highlightImage2: highLInfo.highlightImage2,
        highlightImage2Url: highLInfo.highlightImage2Url,
        mediaDescription2: highLInfo.mediaDescription2,
        paragraph4: paragraph4,
        status: highLInfo.status
      }
      let HighLightEvents = apiserve.e(data)
      window.open(process.env.REACT_APP_FRONTEND_ORIGIN_PREVIEW + 'highlight-preview?data=' + HighLightEvents);
    } else if (["External link"].includes(highLInfo.highlightFormat)) {
      // } else{

      data = {
        id: highLInfo._id,
        highlightType: highLInfo.highlightType === undefined ? "Stories" : highLInfo.highlightType,
        highlightFormat: highLInfo.highlightFormat === undefined ? "Blog Post" : highLInfo.highlightFormat,
        highlightTitle: highLInfo.highlightTitle,
        highLightOpeningText: highLInfo.highLightOpeningText,
        mediaDescription1: highLInfo.mediaDescription1,
        featuredHighlightCTATitle: highLInfo.featuredHighlightCTATitle,
        highlightImage1: highLInfo.highlightImage1,
        featuredHighlightCTAUrl: highLInfo.featuredHighlightCTAUrl,
        highlightImage1Url: highLInfo.highlightImage1,
      }
      if(highLInfo.featuredHighlightCTAUrl){
        window.open(highLInfo.featuredHighlightCTAUrl)
      }
      
    }
    } catch (error) {
      console.log(error);
    }
    
  }

  return (
    <>
      <div className="right_side_wrapper artistView_wrapper">
        <ul className="fpg_admin_tab disp_flex small_list_tab">
          {
            data && data.map((list, index) => {
              return (
                <li className={activetab === index ? 'active' : ''} onClick={() => TabClick(index)} key={index}>
                  <p className="uppercase text_center">
                    <div>
                      {list.label}
                    </div>
                  </p>
                </li>
              )
            })
          }
        </ul>
        <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
          <Link className="back_link" to='/highlights'> <svg width="5" height="10" viewBox="0 0 5 10" fill="none"> <path d="M5 0L0 5L5 10V0Z" fill="black" /> </svg> Back To List</Link>
          <p className="update_date">
            {/* Last Update: {moment(highLInfo.updatedAt).tz("US/Mountain").format('h')}:{moment(highLInfo.updatedAt).tz("US/Mountain").format('mm')} {moment(highLInfo.updatedAt).tz("US/Mountain").format('A')}{' '} */}

            Last Update: {moment.tz(highLInfo.updatedAt, "US/Mountain").format('hh')}:{moment.tz(highLInfo.updatedAt, "US/Mountain").format('mm')} {moment(highLInfo.updatedAt).tz("US/Mountain").format('A')}{' '}
            MT- {moment.tz(highLInfo.updatedAt, "US/Mountain").format('MM/DD/YYYY')}{' '}
            Last Updated By:{" "} {highLInfo.updatedBy && `${highLInfo.updatedBy.fname}${' '} ${highLInfo.updatedBy.lname} `}
          </p>
        </div>
        <div className="fpg_tabcontent">
          {activetab === 0 ?
            isEdit ?
              <div className="edit_featured">
                <div className="featured_container">
                  <form>

                    <div className="field_row horizontal_field d_flex field_label">

                     
                      <DropdownMaster options={type} label="Highlight Type:" name="highlightType" onChange={(e) => dropChange(e)} value={highLInfo.highlightType}/>
                      {/* onChange={(e) => dropChange(e)} */}
                     

                      <DropdownMaster options={highLightFormate} label="Highlight Format:" name="highlightFormat" onChange={(e) => dropChange(e)} value={highLInfo.highlightFormat} disable="true" />
                      {/* disable="true" */}
                    </div>
                    <div className="field_row horizontal_field">
                      <TextField type="text" label="Highlight Title:" name="highlightTitle" value={highLInfo.highlightTitle} onChange={(e) => onInputChange(e)}  fpgerror={validator.current.message('highlightTitle', highLInfo.highlightTitle, 'highlightTitle|required')} />
                    </div>


                    {highLInfo.highlightFormat !== "External link" ?

                      <div className="field_row horizontal_field">
                        <Dropdown options={position} label="Featured Highlight Image Position:" name="featuredHighlightImagePosition" value={highLInfo.featuredHighlightImagePosition} onChange={(e) => dropChange(e)} />
                      </div>
                      :
                       <div className="field_row horizontal_field">
                        <Textarea label="Highlight Opening Text:" name="highLightOpeningText" height="64px" value={highLInfo.highLightOpeningText} onChange={(e) => onInputChange(e)} />
                      </div>
                    }
                    <div className="field_row horizontal_field">
                      <TextField type="text" label="Featured Highlight CTA Title:" name="featuredHighlightCTATitle" value={highLInfo.featuredHighlightCTATitle} onChange={(e) => onInputChange(e)} />
                    </div>

                    <div className="d_flex ">
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Highlight Image:</label>
                          <div className="file_upload_400">
                            <div className="uploads_files">
                              <ImageOnlyUpload
                                item={highLInfo._id}
                                handleImage={(e) => handleImage(e)}
                                deleteImage={(e) => setDeleteImagePopup(true)}
                                iconDelete={true}
                                size="2"
                                id={highLInfo._id}
                                image={imageUrlValue()}
                                value={image()}
                                showDeleteIcon={showDeleteIcon()}
                                ImagePreLoader={imagePreloader}
                                insideOnchange={(e) => insideImagechange(e)}
                                isboth={false}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="field_row">
                        <TextField type="text" label="Media Description:" name="mediaDescription1" value={highLInfo.mediaDescription1} placeholder="Description, Credits, etc." onChange={(e) => onInputChange(e)} />
                      </div>
                    </div>
                  
                    {highLInfo.highlightFormat !== "External link" ?                    
                      <>
                        <div className="field_row horizontal_field">
                          <div className="field_row_inner">
                            <label>Paragraph 1:</label>
                            <div className="field_input relative editor_wrapper">
                              {/* <div className="heading_bg"> </div> */}
                              <div className="bg_white">
                                <Editor
                                  wrapperClassName="sd_text_editor"
                                  name="paragraph1"
                                  editorState={highLInfo?.paragraph1 || ''}
                                  onEditorStateChange={(e) => onEditorStateChange(e, "paragraph1")}
                                  toolbar={{
                                    blockType: {
                                      inDropdown: true,
                                      options: ['Normal', 'Blockquote'],
                                    },
                                    inline: {
                                      inDropdown: true,
                                      options: ['bold', 'italic', 'underline', 'strikethrough'],
                                    },
                                    list: {
                                      inDropdown: true,
                                      options: ['unordered', 'ordered'],
                                    },
                                    textAlign: { inDropdown: true },
                                    link: { inDropdown: true },
                                    history: { inDropdown: true },
                                    options: ['inline', 'blockType', 'list', 'link', 'textAlign',],

                                  }}
                                  editorStyle={{ height: '200px' }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="field_row horizontal_field">
                          <Textarea type="text" label="Quote:" height="64px" name="quote" value={highLInfo.quote} onChange={(e) => onInputChange(e)} />
                        </div>
                        <div className="field_row horizontal_field">
                          <TextField type="text" label="Quote By:" name="quoteBy" value={highLInfo.quoteBy} onChange={(e) => onInputChange(e)} />
                        </div>
                        <div className="field_row horizontal_field">
                          <div className="field_row_inner">
                            <label>Paragraph 2:</label>
                            <div className="field_input relative editor_wrapper">
                              {/* <div className="heading_bg"> </div> */}
                              <div className="bg_white">
                                <Editor
                                  wrapperClassName="sd_text_editor"
                                  name="paragraph2"
                                  editorState={highLInfo.paragraph2 || ''}
                                  onEditorStateChange={(e) => onEditorStateChange(e, "paragraph2")}
                                  toolbar={{
                                    blockType: {
                                      inDropdown: true,
                                      options: ['Normal', 'Blockquote'],
                                    },
                                    inline: {
                                      inDropdown: true,
                                      options: ['bold', 'italic', 'underline', 'strikethrough'],
                                    },
                                    list: {
                                      inDropdown: true,
                                      options: ['unordered', 'ordered'],
                                    },
                                    textAlign: { inDropdown: true },
                                    link: { inDropdown: true },
                                    history: { inDropdown: true },
                                    options: ['inline', 'blockType', 'list', 'link', 'textAlign',],

                                  }}
                                  editorStyle={{ height: '200px' }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="d_flex ">
                          <div className="field_row horizontal_field">
                            <div className="field_row_inner">
                              <label></label>
                              <div className="file_upload_400">
                                {highLInfo.highlightImage2?.match(/\.(jpeg|jpg|gif|png|jfif)$/) != null || highLInfo.highlightImage2Url?.match(/\.(jpeg|jpg|gif|png|jfif)$/) != null
                                  ?
                                  <>
                                    <div className="uploads_files">
                                      <VideoImageFile
                                        item={highLInfo._id}
                                        handleImage={(e) => onChangeFile(e)}
                                        iconDelete={true}
                                        size="2"
                                        id={highLInfo._id}
                                        image={highLInfo.highlightImage2Url}
                                        showDeleteIcon={highLInfo.highlightImage2}
                                        value={highLInfo.highlightImage2 ? apiserve.imageUrl + highLInfo.highlightImage2 : highLInfo.highlightImage2Url}
                                        insideOnchange={(e) => insideFilechange(e)}
                                        videoPreLoader={videoPreLoader}
                                        deleteImage={(e) => setDeleteFilePopup(true)}
                                        isboth={true} />
                                    </div>
                                  </>
                                  :
                                  <div className="uploads_files">
                                    <VideoOnlyUpload
                                      handleVideo={(e, ref) => onChangeFile(e, ref)}
                                      url={highLInfo.highlightImage2 ? `${apiserve.imageUrl}${highLInfo.highlightImage2}` : highLInfo.highlightImage2Url}
                                      video={highLInfo.highlightImage2 ? `${apiserve.imageUrl}${highLInfo.highlightImage2}` : highLInfo.highlightImage2Url}
                                      videoUrl={highLInfo.highlightImage2Url}
                                      insideOnchange={(e) => insideFilechange(e)}
                                      item={highLInfo}
                                      iconDelete={true}
                                      showDeleteIcon={highLInfo.highlightImage2}
                                      videoPreLoader={videoPreLoader}
                                      setErrorMsg={setErrorMsg} setErrorPopup={setErrorPopup}
                                      deleteVideo={() => setDeleteFilePopup(true)}
                                      uploadmessage="Upload PNG/JPEG of max size of 2MB OR MP4 of max size 100MB"
                                    />
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                          <div className="field_row">
                            <TextField type="text" name="mediaDescription2" label="Media Description:" value={highLInfo.mediaDescription2} placeholder="Description, Credits, etc." onChange={(e) => onInputChange(e)} />
                          </div>
                        </div>
                        <div className="field_row horizontal_field">
                          <div className="field_row_inner">
                            <label>Paragraph 3:</label>
                            <div className="field_input relative editor_wrapper" >
                              {/* <div className="heading_bg"> </div> */}
                              <div className="bg_white">
                                <Editor
                                  wrapperClassName="sd_text_editor"
                                  name="paragraph3"
                                  editorState={highLInfo.paragraph3 || ''}
                                  onEditorStateChange={(e) => onEditorStateChange(e, "paragraph3")}
                                  toolbar={{
                                    blockType: {
                                      inDropdown: true,
                                      options: ['Normal', 'Blockquote'],
                                    },
                                    inline: {
                                      inDropdown: true,
                                      options: ['bold', 'italic', 'underline', 'strikethrough'],
                                    },
                                    list: {
                                      inDropdown: true,
                                      options: ['unordered', 'ordered'],
                                    },
                                    textAlign: { inDropdown: true },
                                    link: { inDropdown: true },
                                    history: { inDropdown: true },
                                    options: ['inline', 'blockType', 'list', 'link', 'textAlign',],

                                  }}
                                  editorStyle={{ height: '200px' }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                       
                        <div className="field_row horizontal_field">
                          <div className="field_row_inner">
                            <label>Paragraph 4:</label>
                            <div className="field_input relative editor_wrapper">
                              {/* <div className="heading_bg"> </div> */}
                              <div className="bg_white">
                                <Editor
                                  wrapperClassName="sd_text_editor"
                                  name="paragraph4"
                                  editorState={highLInfo.paragraph4 || ''}
                                  onEditorStateChange={(e) => onEditorStateChange(e, "paragraph4")}
                                  toolbar={{
                                    blockType: {
                                      inDropdown: true,
                                      options: ['Normal', 'Blockquote'],
                                    },
                                    inline: {
                                      inDropdown: true,
                                      options: ['bold', 'italic', 'underline', 'strikethrough'],
                                    },
                                    list: {
                                      inDropdown: true,
                                      options: ['unordered', 'ordered'],
                                    },
                                    textAlign: { inDropdown: true },
                                    link: { inDropdown: true },
                                    history: { inDropdown: true },
                                    options: ['inline', 'blockType', 'list', 'link', 'textAlign',],

                                  }}
                                  editorStyle={{ height: '200px' }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                      :
                      <div className="field_row horizontal_field">
                        <TextField type="text" label="Highlight CTA URL:" name="featuredHighlightCTAUrl" value={highLInfo.featuredHighlightCTAUrl} onChange={(e) => onInputChange(e)} />
                      </div>
                    }
                    <div className="text_center field_row w_100 buttons_outer">
                      <button className="uppercase" type="button" onClick={() => cancelFn()}>CANCEL</button>
                      {highLInfo.highlightFormat !== "External link" &&
                        <button className="uppercase prev_btn" onClick={(e) => previewRecordTalk(e)}>PREviEW</button>
                      }
                      <button className="uppercase active" type="button" onClick={() => editHighLight(highLInfo._id)}>SAVE</button>
                    </div>
                  </form>
                </div>
              </div>
              :
              <div className="view_featured">
                <div className="page_bg">
                  <div className="fpg_edits_links d_flex d_flex_align_center d_flex_justify_center">
                    <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => EditFeatured()}><FpgeeditIcon />EDIT</Link>
                    {highLInfo.status === 1
                      ? <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => handleDisableHighLight(highLInfo._id, highLInfo.status)}><FpgDisableIcon /> DISABLE</Link>
                      : <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => handlePublishHighLight(highLInfo._id, highLInfo.status)}><FpgpublishIcon /> PUBLISH</Link>
                    }
                    <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => handleDeleteHighLight()}>
                      <FpgDeleteIcon />
                      DELETE
                    </Link>
                  </div>
                  <div className="feature_view">
                    <div className="news_date d_flex d_flex_align_center mb_10 mt_15">
                      <label>{highLInfo.highlightType}</label>
                      <span>Posted on</span>
                      <p>{moment(highLInfo.updateAt).format('MM/DD/YYYY')}-{moment(highLInfo.updateAt).format('h')}:{moment(highLInfo.updateAt).format('mm')}:{moment(highLInfo.updateAt).format('A')}</p>
                    </div>


                    {highLInfo.highlightFormat !== "External link" &&
                      <>
                        <h3 className="mb_15 feature_title">{highLInfo.highlightTitle}</h3>
                        <div className="highlight_banner">
                          <img src={highLInfo.highlightImage1 ? apiserve.imageUrl + highLInfo.highlightImage1 : highLInfo.highlightImage1Url} />
                          <p className="sub_desc" dangerouslySetInnerHTML={{ __html: highLInfo.mediaDescription1 }}></p>
                        </div>
                        <div className="highlight_content">
                          {highLInfo.paragraph1 && <p dangerouslySetInnerHTML={{ __html: covertToHtml(highLInfo.paragraph1) }}></p>}
                            <>
                            {highLInfo.quote === "" ?"":
                              <div className="mb_15">
                                  <blockquote>
                                      {highLInfo.quote}
                                  </blockquote>
                                <p className="uppercase text_right"> -{highLInfo.quoteBy} </p>
                              </div>
                                
                            }
                          </>
                          {highLInfo.paragraph2 && <p dangerouslySetInnerHTML={{ __html: covertToHtml(highLInfo.paragraph2) }}></p>}
                              
                          {EXT_IMAGES.test(highLInfo.highlightImage2) ||  EXT_IMAGES.test(highLInfo.highlightImage2Url) ? 
                              <div className="media_image ">
                                  <img src={highLInfo.highlightImage2 ? apiserve.imageUrl + highLInfo.highlightImage2 : highLInfo.highlightImage2Url} />
                              </div>:  
                            <div className="video_wrap mb_15">
                              {/* {EXT_VIDEO.test(highLInfo.highlightImage2Url) ?  */}
                              
                              <iframe src={highLInfo.highlightImage2 ? apiserve.imageUrl + highLInfo.highlightImage2 : highLInfo.highlightImage2Url} />
                              {/* :<img src={highLInfo.highlightImage2 ? apiserve.imageUrl + highLInfo.highlightImage2: highLInfo.highlightImage2Url} /> */} 
                            </div>
                          }
                        
                          <p className="sub_desc">{highLInfo.mediaDescription2}</p>
                          {highLInfo.paragraph3 && <p dangerouslySetInnerHTML={{ __html: covertToHtml(highLInfo.paragraph3) }}></p>}

                          <p className="vid_subtitle mb_15">{highLInfo.mediaDescription4}</p>
                          {highLInfo.paragraph4 && <div className="editor_view" dangerouslySetInnerHTML={{ __html: covertToHtml(highLInfo.paragraph4) }} />}


                        </div>
                      </>
                    }
                   
                    {highLInfo.highlightFormat === "External link" &&
                      <div className="highlight_banner">
                        <img src={highLInfo.highlightImage1 ? apiserve.imageUrl + highLInfo.highlightImage1 : highLInfo.highlightImage1Url} />
                        <p className="sub_desc" dangerouslySetInnerHTML={{ __html: highLInfo.mediaDescription1 }}></p>
                        <h3 className="mb_15 feature_title">{highLInfo.highlightTitle}</h3>
                        <p className="sub_desc">{highLInfo.highLightOpeningText}</p>
                        <a href={highLInfo.featuredHighlightCTAUrl}>{highLInfo.featuredHighlightCTAUrl}</a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            : ""
          }
          {activetab === 1 &&
            <HighlightsFh />
          }
        </div>
      </div>
      {errorMsg &&
        <ErrorPopUp
          errorMsg={errorMsg}
          errorMsgPopup={() => {
            setErrorMsg("")
            setErrorPopup(false)
          }}
        />}
      {publishHighLight ?
        <PopUpCustomAll
          HeaderName='Publish Changes'
          insideDetails='Saving the current changes will publish it to the production site'
          insideData='Do you want to proceed?'
          popupState={closeAdminUser()}
          yesPopUp={publishHighLightPopupYes()}
        />
        : ''}
      {disableHighLight ? (
        <PopUpCustomAll
          HeaderName='Disable?'
          insideDetails='You are about to disable an item, which will temporarily make it unavailable on the production site'
          insideData='Do you want to proceed?'
          popupState={closeAdminUser()}
          yesPopUp={disableHighLightPopupYes()} />)
        : ('')}

      {deleteHighLight
        ? <PopUpCustomAll
          HeaderName='Delete?'
          insideDetails='You are about to delete an item and this action is permanent'
          insideData='Do you want to proceed?'
          popupState={() => closeAdminUser()}
          yesPopUp={() => deleteHighLightPopupYes()} />
        : ''}

      {deleteFilePopup
        ? <PopUpCustomAll
          HeaderName="Delete video?"
          insideDetails="Are You Sure ?"
          insideData="Are you sure you want to delete this video or image?"
          popupState={() => closeAdminUser()}
          yesPopUp={() => onDeleteFilePopup()} />
        : ""
      }
      {deleteImagePopup
        ? <PopUpCustomAll
          HeaderName="Delete Image?"
          insideDetails="Are You Sure ?"
          insideData="You want to delete this image"
          popupState={() => closeAdminUser()}
          yesPopUp={() => onDeleteImagePopup()} />
        : ""
      }
    </>

  )
}
export default connect(null, mapDispatchToProps)(HighlightDetailView)

